import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListTokenAuthAdminResponse } from '../../responses/user/list-token-auth-admin.response';
import { TokenAuthAdminResponse } from '../../responses/user/token-auth-admin.response';
import { TokenAuthAdminModel } from '../../models/user/token-auth-admin.model';
import { ListUserResponse } from '../../responses/user/list-user.response';

@Injectable({
  providedIn: 'root'
})
export class UserService extends CommonService{
  
  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }
  
  public getUserWithAccessInMasterModule(idHealthUnit:number): Observable<ListUserResponse> {
    
    let uri = 'User'  
    
    uri = uri+ `/idHealthUnit/${idHealthUnit}`;
    
    return this.httpClient.get<ListUserResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
    
    